import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import Icon from '@/components/Icon/Icon';
import { HStack } from '@/components/Layout';
import { Text } from '@/components/Typography/Text';
import type { FolderLinkValue } from '@/features/section-attribute/types';
import { CFormItemBase, type CFormItemProps, buildCFormItem } from '../CFormItem';
type Props = CFormItemProps & {
  /** フォルダID */
  folderId: string | null;
  /** フォルダ名 */
  folderName: string | null;
  /** 遷移先パス（省略時はリンクなし） */
  linkTo?: string;
  /** 編集モード時の値変更ハンドラ */
  onChange?: (value: FolderLinkValue | null) => void;
  /** 読取時のカスタムコンポーネント */
  readComponent?: ReactNode;
  /** 編集時のカスタムコンポーネント（フォルダ選択UIなど） */
  writeComponent?: ReactNode;
};

/**
 * Card-based Form / FolderLinkItem
 *
 * フォルダリンク表示コンポーネント
 * フォルダアイコン + 名前 + リンクとして表示
 * Parent Folder 表示で使用
 * writeComponent を指定することで編集モードに対応
 */
export const CFormFolderLinkItem = buildCFormItem<Props>((props: Props) => {
  const defaultReadComponent = props.folderId != null && props.folderName != null ? <HStack className="items-center gap-1.5">
        <Icon iconName="FolderIcon" className="size-5 shrink-0" />
        {props.linkTo ? <Link to={props.linkTo} params={{
      id: props.folderId
    }} className="truncate font-semibold hover:underline">
            <Text variant="pSmall">{props.folderName}</Text>
          </Link> : <Text variant="pSmall" className="truncate font-semibold">
            {props.folderName}
          </Text>}
      </HStack> : <Text variant="pSmall" className="text-neutral-muted-on-fill">
        -
      </Text>;
  return <CFormItemBase {...props} readComponent={props.readComponent ?? defaultReadComponent} writeComponent={props.writeComponent} />;
});